const menuItems = [
  {
    name: "オーダーメイド施術",
    desc: "身体の状態を評価し、その人に合った施術を行います。慢性的な不調から、パフォーマンス向上まで対応。",
    note: "頭蓋骨矯正との組み合わせ可",
    prices: [
      { time: "45分", price: "¥5,000" },
      { time: "60分", price: "¥6,000" },
      { time: "90分", price: "¥8,000" },
      { time: "120分", price: "¥10,000" },
    ],
  },
  {
    name: "スポーツ整体",
    desc: "骨格調整・筋膜リリース・ストレッチを組み合わせ、可動域を広げ、動きやすい身体へ。",
    note: "",
    prices: [
      { time: "45分", price: "¥5,000" },
      { time: "60分", price: "¥6,000" },
      { time: "90分", price: "¥8,000" },
      { time: "120分", price: "¥10,000" },
    ],
  },
  {
    name: "頭蓋骨矯正",
    desc: "顔の歪み・左右差・たるみにアプローチ。フェイスラインと自律神経を整えます。",
    note: "",
    prices: [
      { time: "30分", price: "¥3,000" },
      { time: "45分", price: "¥4,500" },
      { time: "60分", price: "¥6,000" },
    ],
  },
  {
    name: "パーソナルトレーニング",
    desc: "姿勢改善・ボディメイク・ブライダルなど、目的に合わせた身体づくり。",
    note: "",
    prices: [
      { time: "20分", price: "¥2,000" },
      { time: "30分", price: "¥3,000" },
      { time: "45分", price: "¥4,500" },
      { time: "60分", price: "¥6,000" },
    ],
  },
  {
    name: "キックボクシングパーソナル",
    desc: "プロによる指導。未経験OK。脂肪燃焼・ストレス発散・運動習慣づくりに。",
    note: "",
    prices: [
      { time: "20分", price: "¥2,000" },
      { time: "30分", price: "¥3,000" },
      { time: "45分", price: "¥4,500" },
      { time: "60分", price: "¥6,000" },
    ],
  },
];

export default function Menu() {
  return (
    <section id="menu" className="py-24 bg-[#f2ede3]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#3a4a28]/50 text-xs tracking-[0.4em] mb-4">MENU</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2a2a1e] mb-4">
            メニュー・料金
          </h2>
          <p className="text-[#5a5a4a] text-sm leading-loose max-w-md mx-auto">
            身体の状態をお聞きし、あなたに最適なメニューをご提案します。
          </p>
        </div>

        <div className="space-y-4">
          {menuItems.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border border-[#e0dbd0] overflow-hidden"
            >
              <div className="flex flex-col md:flex-row md:items-start">
                <div className="md:w-64 px-7 py-5 border-b md:border-b-0 md:border-r border-[#e0dbd0] flex-shrink-0">
                  <h3 className="font-serif text-[#2a2a1e] text-base leading-snug tracking-wide mb-2">
                    {item.name}
                  </h3>
                  <p className="text-[#5a5a4a] text-xs leading-relaxed mb-1">{item.desc}</p>
                  {item.note && (
                    <p className="text-[#3a4a28]/60 text-[11px] mt-1 leading-snug">
                      ※{item.note}
                    </p>
                  )}
                </div>
                <div className="flex flex-wrap gap-px flex-1 bg-[#e0dbd0]">
                  {item.prices.map((p, j) => (
                    <div
                      key={j}
                      className="flex-1 min-w-[80px] bg-white px-5 py-4 text-center"
                    >
                      <p className="text-[#3a4a28] text-xs tracking-wider mb-1.5 bg-[#3a4a28]/8 rounded-full px-2 py-0.5 inline-block">
                        {p.time}
                      </p>
                      <p className="font-serif text-[#2a2a1e] text-base font-medium">
                        {p.price}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-[#8a8a7a] text-xs mt-8 tracking-wide">
          ※表示価格はすべて税込です。
        </p>
      </div>
    </section>
  );
}
